import "./App.css";
import App2 from "./App2";
import React, { StrictMode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRoot } from "react-dom/client";

const queryClient = new QueryClient();

document.addEventListener("DOMContentLoaded", function () {
  const rootElement = document.getElementById("root")!;
  const root = createRoot(rootElement);

  root.render(

    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App2 />
      </QueryClientProvider>
    </StrictMode>
  );
});